<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div class="container" style="padding-top: 2vh; text-align: center">

    <div (click)="toLocations()" class="row location">

      <div class="col-3 text-right">
        <span class="material-icons-outlined customRowIcon textXXM">place</span>
      </div>

      <div class="col-9">
        <h3 class="centerVert text-center textM">{{this.proyectoService.getProyectoActual().nombre}}</h3>
      </div>

    </div>

    <img class="warImg" src="../../../assets/img/Warnings.png" alt="Warnings image">

  </div>
</div>
